<!--<div class="video-player">-->
  <rs-penpencil-player
    *ngIf="playerConfig && playerConfig.sources && playerConfig.sources.length"
    [playerConfig]="playerConfig"></rs-penpencil-player>
<!--</div>-->
